// infinite-scroll.js

let currentPage = 1;
let isLoading = false;

// Change this selector to whatever wraps your product cards
const productGridSelector = ".product-grid";
const productCardSelector = ".product-card"; // adjust if needed
const threshold = 300; // Load next page 300px before bottom

function onScroll() {
  if (isLoading) return;

  const scrollPosition = window.innerHeight + window.scrollY;
  const nearBottom = document.body.offsetHeight - threshold;

  if (scrollPosition >= nearBottom) {
    loadMoreProducts();
  }
}

function loadMoreProducts() {
  const urlParams = new URLSearchParams(window.location.search);
  currentPage++;
  urlParams.set("page", currentPage);

  isLoading = true;

  fetch(`${window.location.pathname}?${urlParams.toString()}`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Grab the next set of product cards
      const newItems = doc.querySelectorAll(
        `${productGridSelector} ${productCardSelector}`
      );

      // Append new items to the existing grid
      newItems.forEach((item) => {
        document.querySelector(productGridSelector).appendChild(item);
      });

      // Stop if no more products
      if (newItems.length === 0) {
        window.removeEventListener("scroll", onScroll);
      }

      isLoading = false;
    })
    .catch((err) => {
      console.error("Infinite scroll error:", err);
      isLoading = false;
    });
}

// Setup scroll listener
window.addEventListener("scroll", onScroll);
